import React, { useState, useEffect } from "react";
import { Dropdown, Row, Tab, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import {
  downloadAllPlayers,
  getAllReportPlayer,
  getDuesPlayersInvoice,
  getPlayerSubscription,
} from "../../../../services/academicService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import DuesPaymentModal from "../../../components/reports/DuesPaymentModal";
import {
  getPublicAgeCategory,
  getPublicPaymentStatus,
} from "../../../../services/publicService";
import { getTenantEmailReport } from "../../../../services/ReportService";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Tenant Name", sortingVale: "tenantName" },
  { heading: "Tenant Email", sortingVale: "tenantEmail" },
  { heading: "Owner Name", sortingVale: "ownerName" },
  { heading: "Owner Email", sortingVale: "ownerEmail" },
  { heading: "Owner Mobile", sortingVale: "ownerMobile" },
  { heading: "Subject", sortingVale: "subject" },
  { heading: "Date", sortingVale: "date" },
  { heading: "Template Code", sortingVale: "templateCode" },
  { heading: "Status", sortingVale: "status" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const EmailReport = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentStart, setCurrentStart] = useState(0);
  const [paymentModal, setPaymentModal] = useState(false);
  //filter
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [dueList, setDueList] = useState([]);
  const [ageCategory, setAgeCategory] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageData, setPackageData] = useState(null);
  const [open, setOpen] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [downloading, setDownloading] = useState(false);
  //palyer dropdown
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0); // 0-based
  const [tenantSearch, setTenantSearch] = useState("");
  const pageSize = 20;
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  const formatDate = (date) => {
    if (!date) return null;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getTenantEmailReport(
        page,
        size,
        search,
        formatDate(startDate),
        formatDate(endDate),
        selectedStatus,
      );
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({
      page,
      size,
      search,
      startDate,
      endDate,
      selectedStatus
    });
  }, [page, size, search, startDate, endDate, selectedStatus]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "tenantName":
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.tenant?.name || "").localeCompare(b?.tenant?.name || "")
            : (b?.tenant?.name || "").localeCompare(a?.tenant?.name || ""),
        );
        break;

      case "tenantEmail":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.tenant?.email || "").localeCompare(b?.tenant?.email || "")
            : (b?.tenant?.email || "").localeCompare(a?.tenant?.email || ""),
        );
        break;

      case "ownerName":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.tenant?.owner?.name || "").localeCompare(b?.tenant?.owner?.name || "")
            : (b?.tenant?.owner?.name || "").localeCompare(a?.tenant?.owner?.name || ""),
        );
        break;

      case "ownerEmail":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.tenant?.owner?.email || "").localeCompare(b?.tenant?.owner?.email || "")
            : (b?.tenant?.owner?.email || "").localeCompare(a?.tenant?.owner?.email || ""),
        );
        break;

      case "ownerMobile":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.tenant?.owner?.phone || "").localeCompare(b?.tenant?.owner?.phone || "")
            : (b?.tenant?.owner?.phone || "").localeCompare(a?.tenant?.owner?.phone || ""),
        );
        break;

      case "subject":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.subject || "").localeCompare(b?.subject || "")
            : (b?.subject || "").localeCompare(a?.subject || ""),
        );
        break;

      case "date":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.createdOn || "").localeCompare(b?.createdOn || "")
            : (b?.createdOn || "").localeCompare(a?.createdOn || ""),
        );
        break;

      case "templateCode":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.templateCode || "").localeCompare(b?.templateCode || "")
            : (b?.templateCode || "").localeCompare(a?.templateCode || ""),
        );
        break;

      case "status":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a?.send === b?.send ? 0 : a?.send ? 1 : -1)
            : (a?.send === b?.send ? 0 : a?.send ? -1 : 1),
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  const downloadExcel = async () => {
    try {
      setDownloading(true);
      const res = await getTenantEmailReport(
        0,
        1000,
        search,
        formatDate(startDate),
        formatDate(endDate),
        selectedStatus,
      );

      const list = Array.isArray(res)
        ? res
        : Array.isArray(res?.content)
          ? res.content
          : Array.isArray(userData)
            ? userData
            : [];

      if (!list || list.length === 0) {
        toast.warn("No data available to download");
        return;
      }

      const formattedData = list.map((data, index) => ({
        "S.No": index + 1,
        "Tenant Name": data?.tenant?.name || "",
        "Tenant Email": data?.tenant?.email || "",
        "Owner Name": data?.tenant?.owner?.name || "",
        "Owner Email": data?.tenant?.owner?.email || "",
        "Owner Mobile": data?.tenant?.owner?.phone || "",
        Subject: data?.subject || "",
        Date: data?.createdOn || "",
        "Template Code": data?.templateCode || "",
        Status: data?.send ? "True" : "False",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Email Reports");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "tenant-email-reports.xlsx");
      toast.success("Excel report downloaded successfully");
    } catch (error) {
      console.error("Excel download failed:", error);
      toast.error("Excel download failed");
    } finally {
      setDownloading(false);
    }
  };




  return (
    <>
      <PageTitle activeMenu={"Email Reports"} motherMenu={"Reports"} />
      <div className="filter cm-content-box box-primary">
        <div className={`content-title`} onClick={() => setOpen(!open)}>
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
            >
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">

                <div className="col-md-3">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setEndDate(null); // reset end date
                    }}
                    maxDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select start date"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    minDate={startDate}
                    maxDate={
                      startDate
                        ? new Date(
                          new Date(startDate).setDate(
                            startDate.getDate() + 90,
                          ),
                        )
                        : new Date()
                    }
                    disabled={!startDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select end date"
                  />
                </div>
                <div className="col-xl-3">
                  <label className="form-label">Email Send</label>
                  <Select
                    isSearchable={false}
                    options={[
                      { value: "", label: "Select Status" },
                      { value: "true", label: "True" },
                      { value: "false", label: "False" },
                    ]}
                    className="custom-react-select"
                    onChange={(e) => setSelectedStatus(e.value)}
                    placeholder="Select Status"
                  />
                </div>
                <div className="col-xl-3 col-sm-6 d-flex align-items-end mt-3">
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ height: "2.8rem" }}
                    onClick={downloadExcel}
                    disabled={downloading}
                  >
                    <i className={`fas ${downloading ? "fa-spinner fa-spin" : "fa-file-excel"} me-2`}></i>
                    {downloading ? "Downloading..." : "Download"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder=""
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{currentStart * size + ind + 1}</td>
                                  <td>{data?.tenant?.name}</td>
                                  <td>{data?.tenant?.email}</td>
                                  <td>{data?.tenant?.owner?.name}</td>
                                  <td>{data?.tenant?.owner?.email}</td>
                                  <td>{data?.tenant?.owner?.phone}</td>
                                  <td>{data?.subject}</td>
                                  <td>{data?.createdOn ? new Date(data?.createdOn +
                                    "Z"
                                  ).toLocaleString() : ""}</td>
                                  <td>{data?.templateCode}</td>
                                  <td>{data?.send ? "True" : "False"}</td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={theadData.length} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td colSpan={theadData.length} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${page === 0 ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${page + 1 >= totalPages ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
      <DuesPaymentModal
        show={paymentModal}
        onClose={() => setPaymentModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setPaymentModal(false);
          fetchUserData({ page, size, search });
        }}
      />
    </>
  );
};

export default EmailReport;
